<template>
  <div class="grid nav">
    <div class="grid identity" v-if="hotel && hotels">
    <el-dropdown trigger="click">
      <span class="el-dropdown-link" style="cursor: pointer;">
        {{hotel.name}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item icon="" v-for="hot in hotels" :key="hot._id" @click.native="setHotel(hot)">{{hot.name}}</el-dropdown-item>
        <el-dropdown-item v-if="$store.state.user.privileges.admin" divided icon="el-icon-circle-plus-outline" @click.native="show('addbeach')">Aggiungi spiaggia</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    </div>
    <div class="grid actions" v-if="hotel && hotels">
        <div class="grid stats">
            <div class="grid stat overview" @click="show('dashboard')">
                <span v-if="!isTablet">Occupazione spiaggia</span>
                <span>{{occupation}}%</span>
                <span class="grid "><unicon name="angle-right-b" /></span>
            </div>
            <div class="grid stat overview checkin" @click="CheckinlistDialog = !CheckinlistDialog, showlist = {checkins: true, checkouts: false}" :class="{'active': checkin.length > 0 }">
                <span v-if="!isTablet">Check In</span>
                <span>{{checkin.length}}</span>
                <span class="grid "><unicon name="angle-right-b" /></span>
                <!-- <span class="grid "><i class="fas fa-angle-right"></i></span> -->
            </div>
            <div class="grid stat overview checkout" @click="CheckinlistDialog = !CheckinlistDialog, showlist = {checkins: false, checkouts: true}" :class="{'active': checkout.length > 0 }">
                <span v-if="!isTablet">Check Out</span>
                <span>{{checkout.length}}</span>
                <span class="grid "><unicon name="angle-right-b" /></span>
            </div>
        </div>
        <!-- <button @click="convert()">convert</button> -->
        <!-- <button @click="reset()">reset</button> -->
        <!-- <button @click="$store.dispatch('ombrelloni/getOmbrelloni')">getombrelloni</button> -->
        <!-- <button @click="$store.dispatch('guests/getGuests')">getGuests</button> -->
    </div>
    <div class="grid footer">
        <!-- {{needstoconvert}} -->
        <!-- {{$store.state.user}} -->
        <!-- {{updateExists}} -->
        <button v-if="updateExists" class="btn red" @click="refreshApp">Update disponibile</button>
        <!-- {{$store.state.hotels.selecthoteldialog}} -->
    </div>

    <el-dialog
        title="Seleziona spiaggia"
        :visible.sync="sethotelDialog || $store.state.hotels.selecthoteldialog"
        width="fit-content"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="grid hotelselector">
        <div class="grid list">
            <div class="grid flatbox" v-for="hot in hotels" :key="hot._id" @click="setHotel(hot), sethotelDialog = false">{{hot.name}}</div>
            <div class="spacer xs"></div>
            <button class="btn green sm" @click="show('addbeach')">aggiungi spiaggia</button>
        </div>
    </el-dialog>

    <el-dialog
        title=""
        :visible.sync="CheckinlistDialog"
        width="fit-content"
        custom-class="Checkinlist">
        <Checkinlist :checkins="checkin" :checkouts="checkout" :showlist="showlist" :today="today" @openSeatNavbar="openSeat"></Checkinlist>
    </el-dialog>

    <el-dialog
        title=""
        :visible.sync="ChangeitemslistDialog"
        width="fit-content"
        custom-class="Changeitemslist">
        <Changeitemslist :checkins="checkin" :checkouts="checkout" :showlist="showlist" :today="today" @openSeatNavbar="openSeat"></Changeitemslist>
    </el-dialog>

    <el-dialog
        title=""
        :visible.sync="needstoconvert"
        width="fit-content"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="needstoconvert">
        <template slot="title">
          <div class="grid header">
            <div class="title" style="font-size: 20px;">Oh boy</div>
          </div>
        </template>
        <div>
            <h3>Doviamo convertire i dati</h3>
            <div class="spacer xs"></div>
            <p>Abbiamo apportato diverse modifiche alla nostra App per migliorare la usabilitá e darti piu flessibilitá.</p>
            <!-- <span class="btn reddark sm"><unicon name="thumbs-up" fill="#fff" /> ok, se proprio doviamo</span> -->
            <div class="grid actions" style="grid-auto-flow: column; padding: 0; margin-top: 64px; justify-content: end; grid-column-gap: 24px;">
              <span @click="needstoconvert = false, sethotelDialog = true" class="btn secondary light sm">cambia spiaggia</span>
              <span class="btn reddark sm" @click="convert()"><unicon name="thumbs-up" fill="#fff" /> ok, se proprio doviamo</span>
            </div>
        </div>
    </el-dialog>

    <Errordialog :errordialog="errordialog" v-if="errordialog.open" @close="errordialog.open = false, $store.state.jwt = {}, $router.replace('/login')"></Errordialog>

  </div>
</template>

<script>
import helper from '../Mixins/helper'
import _ from 'lodash'
import moment from 'moment'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import Checkinlist from '@/components/micro/Checkinlist'
import Changeitemslist from '@/components/micro/Changeitemslist'
import Errordialog from '@/components/micro/Errordialog.vue'
export default {
  name: 'Navbar',
  mixins: [helper],
  props: {
    hotel: Object,
    guestList: Array,
    today: moment()
  },
  data () {
    return {
        isTablet: isTablet,
        isMobileOnly: isMobileOnly,
        sethotelDialog: false,
        CheckinlistDialog: false,
        ChangeitemslistDialog: false,
        showlist: {
            checkins: false,
            checkouts: false
        },
        needstoconvert: false,
        checkindata: '',
        errordialog: {
            open: false,
            title: '',
            message: ''
        }
    }
  },
  components: {
    Checkinlist,
    Changeitemslist,
    Errordialog
  },
  methods: {
    openSeat () {
        // console.log('checkin navbar: ', checkindata)
        this.CheckinlistDialog = false
    },
    convert () {
        this.$store.dispatch('guests/convert').then(() => {
            this.$store.dispatch('hotels/getHotels')
            this.$store.dispatch('ombrelloni/getOmbrelloni')
            this.$store.dispatch('guests/getGuests')
        })
    },
    reset () {
        this.$store.dispatch('guests/reset')
    },
    show (section) {
      console.log(section)
      this.$emit('open', section)
    },
    setHotel (hotel) {
        console.log(hotel)
        console.log('setHotel')
        this.$store.dispatch('getUser')
        this.$store.commit('hotels/SET_ACTIVEHOTEL', hotel)
        console.log(this.$store.state.ombrelloni.ombrelloni.length)
        var privileges
        if (hotel.user === this.$store.state.user.id) {
            privileges = {
                owner: true,
                admin: true
            }
        } else {
            privileges = _.find(this.$store.state.user.profile.hotels, {hotelid: hotel._id})?.privileges ?? {}
        }
        // console.log('privileges: ', privileges)
        // this.$store.commit('hotels/SET_ACTIVEHOTEL', hotel).then(() => {
        //     console.log('SET_ACTIVEHOTEL success ', this)
        // })
        this.$store.dispatch('ombrelloni/getOmbrelloni').then(() => {
            if (this.$store.state.ombrelloni.ombrelloni.length === 0) {
                console.log('no ombrelloni')
                this.$emit('open', 'editgrid')
            } else {
                this.show('dashboard')         
            }
        })
        this.$store.commit('SET_PRIVILEGES', privileges)
        this.$store.dispatch('guests/getGuests')
        // this.show('dashboard')
        this.$store.commit('hotels/SET_SELECTHOTELDIALOG', false)
        console.log(this.$store.state.ombrelloni.ombrelloni.length)
        // this.$store.commit('guests/SET_GUEST', hotel)
    }
  },
  filters: {

  },
  watch: {
    ombrelloni: {
        // immediate: true,
        deep: true,
        handler (newval) {
            // console.log('watch ombrelloni: ', newval.length, oldval.length)
            // console.log(_.some(newval, ['guestid', undefined]))
            var ombrelloni = _.chain(newval).filter(function (o) {
                return o.guests.length > 0
            }).filter(function (g) {
                // console.log(!_.some(g.guests, 'guestid'))
                return !_.some(g.guests, 'guestid')
            }).value()
            if (ombrelloni.length > 0 && this.$store.state.guests.guests.length > 0 || this.$store.state.hotels.activehotel.seasons.length > 0 && this.$store.state.hotels.activehotel.seasons[0].daterange) {
                console.warn(this.$store.state.hotels.activehotel.name + ' needs to convert')
                this.needstoconvert = true
                // console.log(ombrelloni)
            } else {
                this.needstoconvert = false
            }
        }
    }
  },
  computed: {
    checkin () {
        // console.log(this.guestList)
        var today = moment(this.today).format('DD.MM.YYYY')
        return _.chain(this.guestList).filter({ombrelloni: [{arrival: today}]}).value()
    },
    checkout () {
        // return 0
        var today = moment(this.today).format('DD.MM.YYYY')
        // console.log(_.chain(this.guestList).filter({ombrelloni: [{departure: today}]}).value())
        return _.chain(this.guestList).filter({ombrelloni: [{departure: today}]}).value()
        // return _.filter(this.guestList, function (o) {
        //  // console.log(o.stay.end)
        //  return o.stay.end === today
        // })
    },
    occupation () {
        // var self = this
        // var ombrelloni = _.filter(self.$store.state.ombrelloni.ombrelloni, function (o) {
        //     return o.hotelid === self.$store.state.hotels.activehotel._id
        // })
        // var occupied = _.filter(ombrelloni, function (o) {
        //  return _.filter(o.guests, function (g) {
        //      return moment(self.today).isBetween(moment(g.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(g.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]')
        //  })
        // })
        // console.log('glist: ', this.guestList.length, this.$store.state.ombrelloni.ombrelloni.length, (this.guestList.length / this.$store.state.ombrelloni.ombrelloni.length), (0 / 0))
        return this.$store.state.ombrelloni.ombrelloni.length > 0 ? ((this.guestList.length / this.$store.state.ombrelloni.ombrelloni.length) * 100).toFixed() : 0
        // return ((occupied.length / ombrelloni.length) * 100).toFixed()
    },
    hotels () {
        return this.$store.state.hotels.hotels
    },
    ombrelloni () {
        return this.$store.state.ombrelloni.ombrelloni
    }
  },
  beforeMount () {
    // this.$store.dispatch('ombrelloni/getOmbrelloni')
    // this.$store.dispatch('guests/getGuests')
    // if (this.$store.state.hotels.activehotel.segments.length === 0) {
    //     console.log('no segments in activehotel')
    // }
  },
  created () {
    // console.log(this.$store.state.hotels.activehotel._id)
    if (this.$store.state.hotels.hotels.length === 0) {
        console.warn('no beaches ', isMobileOnly)
        // this.sethotelDialog = true
        if (isMobileOnly) {
            console.warn(this.errordialog)
            this.errordialog = {
                open: true,
                title: 'Attenzione',
                message: 'Sembra che non hai nessuna spiaggia attiva, ti invitiamo a crearne una usando un dispositivo Desktop o Tablet per avere la esperienza migliore.'
            }
        } else {
            this.show('addbeach')
        }
    } else if (this.$store.state.hotels.activehotel?._id === undefined) {
        console.log('sdad')
        this.sethotelDialog = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
